import type { BoardDto } from '@mm/shared';
import { apiFetch } from './client';

export type MyProfile = {
  student: { id: string; fullName: string; grade: string | null };
  tutor: { name: string };
};

export async function getMyProfile(): Promise<MyProfile> {
  const res = await apiFetch('/my/profile');
  if (!res.ok) throw new Error(`getMyProfile ${res.status}`);
  return res.json();
}

export async function listMyBoards(): Promise<{ items: BoardDto[] }> {
  const res = await apiFetch('/my/boards');
  if (!res.ok) throw new Error(`listMyBoards ${res.status}`);
  return res.json();
}
